module.exports = __webpack_public_path__ + "static/media/roof-insulation@2x.83df03a5.jpg";